import { ChangeDetectorRef, Component, Input, ViewChild } from '@angular/core';
import { exportDataGrid as exportDataGridToPdf } from 'devextreme/pdf_exporter';
import { MsalService } from '@azure/msal-angular';
import { exportDataGrid } from 'devextreme/excel_exporter';
import { jsPDF } from 'jspdf';
import { saveAs } from 'file-saver';
import { Workbook } from 'exceljs';
import { ReportManagerService } from '../../services/report-manager.service';
import { Observable, Subject, of } from 'rxjs';
import { catchError, takeLast, takeUntil, tap } from 'rxjs/operators';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ManagementApiService, UserUtilityService } from 'src/app/services';
import DataSource from 'devextreme/data/data_source';
import CustomStore from 'devextreme/data/custom_store';
import { DateAdapter, MAT_DATE_FORMATS } from '@angular/material/core';
import { CustomDateAdapter } from 'src/app/Modules/idms/core/custom-date-adapter';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DxDataGridComponent } from 'devextreme-angular';
import { recurrenceType } from 'src/app/Modules/idms/enums/recurrenceType';
import { DeleteDialogComponent } from 'src/app/shared/info-dialogs/delete-dialog/delete-dialog.component';
import { CustomToastService } from 'src/app/services/custom-toast.service';
import { ReportSubscriptionAddComponent } from '../report-subscription-add/report-subscription-add.component';
import { ConfirmationDialogComponent } from 'src/app/shared/info-dialogs/confirmation-dialog/confirmation-dialog.component';
import { TranslocoService } from '@jsverse/transloco';

@Component({
    selector: 'app-report-subscription',
    templateUrl: './report-subscription.component.html',
    styleUrls: ['./report-subscription.component.scss'],
    providers: [{ provide: DateAdapter, useClass: CustomDateAdapter }],
})
// { provide: MAT_DATE_FORMATS, useValue: CUSTOM_DATE_FORMATS },
export class ReportSubscriptionComponent {
    @ViewChild(DxDataGridComponent, { static: false }) dataGrid: DxDataGridComponent;
    @Input() reportName: string;
    @Input() reportId: string;
    @Input() supportedFileTypes = [];
    destroy$ = new Subject();
    isSubscribe: Subject<any> = new Subject<any>();

    public pageSize = 15;
    public currentPage = 0;
    public totalSize = 0;
    columns: any[] = [];
    datasource: any[] = [];
    currentOrg: string;
    currentInstance: string;
    accountName: string = '';
    customDataSource: any; //DataSource
    pageNumber: number = 1;
    pageIndex: number = 0;
    p: number = 1;
    startIndex: number = 1;
    endIndex: number = 15;
    totalCount: number = 0;
    enableReport: boolean = false;
    tooltip_position = 'above';
    SubscriptionList: any;
    fileTypeList: any;

    constructor(
        private authService: MsalService,
        private reportManagerService: ReportManagerService,
        private modalService: NgbModal,
        private mgmtApi: ManagementApiService,
        private cd: ChangeDetectorRef,
        private ngxUiLoaderService: NgxUiLoaderService,
        private customToastService: CustomToastService,
        private userUtilityService: UserUtilityService,
        private ngbModal: NgbModal,
        private transLocoService: TranslocoService
    ) {}

    ngOnInit(): void {
        this.SubscriptionList = [];
        let columns = [];
        columns.push({ caption: this.transLocoService.translate('IDMS.REPORTS.NAME'), dataField: 'subscription.name' });
        columns.push({ caption: this.transLocoService.translate('IDMS.REPORTS.DESCRIPTION'), dataField: 'subscription.comments' });
        columns.push({
            caption: this.transLocoService.translate('IDMS.REPORTS.RECURRENCE_TYPE'),
            dataField: 'schedule.recurrenceType',
            cellTemplate: 'recurrenceTypeTemplate',
        }); //,
        columns.push({ caption: this.transLocoService.translate('IDMS.REPORTS.LAST_RUN'), dataField: 'lastRunTime', cellTemplate: 'dateTimeTemplate' });
        columns.push({ caption: this.transLocoService.translate('IDMS.REPORTS.LAST_RUN_STATUS'), dataField: 'lastRunStatus' });
        columns.push({ caption: this.transLocoService.translate('IDMS.REPORTS.SCHEDULED'), dataField: 'nextRunTime', cellTemplate: 'dateTimeTemplate' });
        columns.push({ caption: this.transLocoService.translate('IDMS.REPORTS.ACTIONS'), dataField: 'Id', cellTemplate: 'diffCellTemplate' });
        // let column1 = { caption: 'Actions', dataField: 'Id', width: 250, cellTemplate: 'diffCellTemplate' };
        // columns.push(column1);
        this.columns = columns;
        this.initialization();
        this.LoadFileTye();
    }

    initialization(): void {
        if (localStorage.getItem('selectedOrganizationName')) {
            this.currentOrg = localStorage.getItem('selectedOrganizationName');
        }
        if (localStorage.getItem('currentInstanceName')) {
            this.currentInstance = localStorage.getItem('currentInstanceName');
        }
        if (localStorage.getItem('msal.accessToken')) {
            this.accountName = this.authService.instance.getActiveAccount().idTokenClaims.name;
            //Case of demo user, name will be unknown, so construct the name using surname and firstname
            if (this.accountName === 'unknown') {
                if (this.authService.instance.getActiveAccount().idTokenClaims?.surname) {
                    this.accountName =
                        this.authService.instance.getActiveAccount().idTokenClaims.surname +
                        ',' +
                        this.authService.instance.getActiveAccount().idTokenClaims.firstname;
                } else {
                    this.accountName =
                        this.authService.instance.getActiveAccount().idTokenClaims.family_name +
                        ',' +
                        this.authService.instance.getActiveAccount().idTokenClaims.given_name;
                }
            }
        }
        this.datasource = [];
        this.customDataSource = null;
        this.enableReport = true;
        this.LoadReport(this.reportId);
    }

    LoadReport(reportId: string) {
        const isNotEmpty = (value: unknown) => value !== undefined && value !== null && value !== '';

        this.customDataSource = new DataSource({
            store: new CustomStore({
                // key: 'ID',
                load: (loadOptions: any) => {
                    return this.getLastValue(this.GetReport(reportId))
                        .then((response: any) => {
                            if (response?.data?.length > 0) {
                                this.datasource = response?.data;
                                this.enableReport = true;
                            } else {
                                this.enableReport = false;
                                this.datasource = [];
                            }
                            return {
                                data: response?.data,
                                totalCount: response?.totalCount,
                            };
                        })
                        .catch(() => {
                            throw 'Data loading error';
                        });
                },
            }),
        });
    }

    GetReport(reportId: string): Observable<any> {
        return of(this.Load(reportId));
    }

    async Load(reportId: string) {
        this.ngxUiLoaderService.start();

        let resp = await this.mgmtApi.getSubscriptionsByReports(reportId).pipe(takeUntil(this.isSubscribe)).toPromise();
        if (resp) {
            if (resp.success) {
                this.SubscriptionList = resp.response;
                let data = {
                    data: resp.response,
                    totalCount: resp.response?.length,
                };
                if (resp.response?.length > 0) {
                }
                this.ngxUiLoaderService.stop();
                return data;
            } else {
                this.ngxUiLoaderService.stop();

                return null;
            }
        }
    }

    getLastValue<T>(observable: Observable<T>): Promise<T | null> {
        return new Promise<T>((resolve, reject) => {
            let lastValue: T | null = null;
            observable
                .pipe(
                    takeLast(1), // Takes only the last emitted value
                    catchError((error) => {
                        // Catch any errors and reject the Promise
                        reject(error);
                        return [];
                    })
                )
                .subscribe({
                    next: (value) => {
                        lastValue = value;
                    },
                    complete: () => {
                        resolve(lastValue); // Resolve the Promise with the last emitted value
                    },
                });
        });
    }

    MoveToReports(): void {
        this.reportManagerService.isReportSelected.next('mainCard');
    }

    onExporting(e) {
        switch (e.format) {
            case 'pdf':
                const columnWidths = this.columns.map((column) => column.width * 0.6);
                const doc = new jsPDF('l', 'pt');
                doc.setFontSize(14);
                exportDataGridToPdf({
                    jsPDFDocument: doc,
                    component: e.component,
                    columnWidths: columnWidths,
                    loadPanel: {
                        enabled: false,
                    },
                    customizeCell: ({ gridCell, pdfCell }) => {
                        pdfCell.padding.top = 3; // add padding for better readability
                        pdfCell.font.size = 7; // set font size to 7
                    },
                }).then(() => {
                    doc.save(`${this.reportName}.pdf`);
                });
                break;

            case 'xlsx':
                const workbook = new Workbook();
                const worksheet = workbook.addWorksheet(this.reportName);

                exportDataGrid({
                    component: e.component,
                    worksheet,
                    loadPanel: {
                        enabled: false,
                    },
                }).then(() => {
                    workbook.xlsx.writeBuffer().then((buffer) => {
                        saveAs(new Blob([buffer], { type: 'application/octet-stream' }), `${this.reportName}.xlsx`);
                    });
                });
                break;

            case 'json':
                const jsonContent = JSON.stringify(this.datasource, null, 2);
                const blob = new Blob([jsonContent], { type: 'application/json' });
                const downloadLink = document.createElement('a');
                downloadLink.href = window.URL.createObjectURL(blob);
                downloadLink.download = this.reportName.replace(/[^a-zA-Z0-9_\-\.]/g, '_');
                downloadLink.click();
                window.URL.revokeObjectURL(downloadLink.href);
                break;
        }
    }

    AddSubscription() {
        // this.LoadFileTye();
        let dialogRef = this.modalService.open(ReportSubscriptionAddComponent, {
            size: 'lg',
            backdrop: 'static',
        });
        dialogRef.componentInstance.reportName = this.reportName;
        dialogRef.componentInstance.reportId = this.reportId;
        dialogRef.componentInstance.fileTypeList = this.fileTypeList;
        dialogRef.componentInstance.btnTitle = this.transLocoService.translate('IDMS.REPORTS.ADD');
        dialogRef.componentInstance.btnTitle1 = this.transLocoService.translate('IDMS.REPORTS.SEND_SAVE');
        dialogRef.componentInstance.title = this.transLocoService.translate('IDMS.REPORTS.ADD_SUBSCRIPTION');
        dialogRef.result.then((result) => {
            if (result) {
                this.datasource = [];
                this.customDataSource = null;
                this.enableReport = true;
                this.LoadReport(this.reportId);
                this.cd.detectChanges();
            }
        });
    }

    deleteSubscription(data: any) {
        let dialogRef = this.modalService.open(DeleteDialogComponent, {
            size: 'sm',
            keyboard: false,
            backdrop: 'static',
        });
        dialogRef.componentInstance.modalMessage = this.transLocoService.translate('IDMS.REPORTS.ARE_YOU_SURE_YOU_WANT_TO_DELETE_THE_SUBSCRIPTION');

        dialogRef.result.then((result) => {
            if (result) {
                this.ngxUiLoaderService.start();
                var deleteData = {
                    subscriptionId: data.data.subscription.subscriptionId,
                    active: false,
                };

                this.mgmtApi
                    .deleteSubscription([deleteData], this.reportId)
                    .pipe(takeUntil(this.isSubscribe))
                    .subscribe(
                        (res) => {
                            if (res) {
                                this.customToastService.successToast(
                                    this.transLocoService.translate('IDMS.REPORTS.SUBSCRIPTION_REMOVED_SUCCESSFULLY'),
                                    'Success'
                                );
                                this.ngbModal.dismissAll();
                                this.datasource = [];
                                this.customDataSource = null;
                                this.enableReport = true;
                                this.LoadReport(this.reportId);
                                this.cd.detectChanges();
                                //this.LoadDocumentdata(this.startIndex, this.endIndex, this.searchText);
                            } else {
                                this.userUtilityService.errorModelPopup(res.message);
                            }
                            this.ngxUiLoaderService.stop();
                        },
                        (err) => {
                            this.ngxUiLoaderService.stop();
                        }
                    );
            }
        });
    }

    editSubscription(data: any) {
        // this.LoadFileTye();
        let dialogRef = this.modalService.open(ReportSubscriptionAddComponent, {
            size: 'lg',
            backdrop: 'static',
        });
        dialogRef.componentInstance.reportName = this.reportName;
        dialogRef.componentInstance.reportId = this.reportId;
        dialogRef.componentInstance.subscriptionData = data.data;
        dialogRef.componentInstance.fileTypeList = this.fileTypeList;
        dialogRef.componentInstance.btnTitle = this.transLocoService.translate('IDMS.REPORTS.ADD');
        dialogRef.componentInstance.btnTitle1 = this.transLocoService.translate('IDMS.REPORTS.SEND_SAVE');
        dialogRef.componentInstance.title = this.transLocoService.translate('IDMS.REPORTS.EDIT_SUBSCRIPTION');
        dialogRef.componentInstance.RemoveEvent.pipe(takeUntil(this.isSubscribe)).subscribe((data: any) => {
            if (data) {
                this.deleteSubscription(data);
            }
        });
        dialogRef.result.then((result) => {
            if (result) {
                this.datasource = [];
                this.customDataSource = null;
                this.enableReport = true;
                this.LoadReport(this.reportId);
                this.cd.detectChanges();
            }
        });
    }

    getRecurrenceTypeLabel(recurrenceType1: number): string {
        switch (recurrenceType1) {
            case recurrenceType.Hourly:
                return 'Hourly';
            case recurrenceType.Daily:
                return 'Daily';
            case recurrenceType.Weekly:
                return 'Weekly';
            case recurrenceType.Monthly:
                return 'Monthly';
            default:
                return 'None';
        }
    }

    LoadFileTye() {
        this.mgmtApi.getFileTypes().subscribe(
            (result) => {
                if (result.response?.length > 0) {
                    this.fileTypeList = result.response;
                    if (this.supportedFileTypes?.length) {
                        this.fileTypeList = this.fileTypeList.filter((item) => this.supportedFileTypes.includes(item.key));
                    }
                }
            },
            (error) => {
                console.error('Error fetching data:', error);
            }
        );
    }

    sendReportNow(data: any) {
        let dialogRef = this.modalService.open(ConfirmationDialogComponent, {
            size: 'sm',
            keyboard: false,
            backdrop: 'static',
        });
        dialogRef.componentInstance.modalMessage = this.transLocoService.translate('IDMS.REPORTS.ARE_YOU_SURE_YOU_WANT_TO_SEND_THE_REPORT_NOW');

        dialogRef.result.then((result) => {
            if (result) {
                this.ngxUiLoaderService.start();
                var Data = {
                    SubscriptionId: data.data.subscription.subscriptionId,
                    RunImmediately: true,
                };

                this.mgmtApi
                    .sendReportImmediately([Data])
                    .pipe(takeUntil(this.isSubscribe))
                    .subscribe(
                        (res) => {
                            if (res) {
                                this.customToastService.successToast(this.transLocoService.translate('IDMS.REPORTS.REPORT_SENT_SUCCESSFULLY'), 'Success');
                                this.ngbModal.dismissAll();
                                // this.datasource = [];
                                // this.customDataSource = null;
                                // this.enableReport = true;
                                // this.LoadReport(this.reportId);
                                // this.cd.detectChanges();
                            } else {
                                this.userUtilityService.errorModelPopup(res.message);
                            }
                            this.ngxUiLoaderService.stop();
                        },
                        (err) => {
                            this.ngxUiLoaderService.stop();
                        }
                    );
            }
        });
    }

    enableOrdDisable(data: any, Type: number) {
        let dialogRef = this.modalService.open(ConfirmationDialogComponent, {
            size: 'sm',
            keyboard: false,
            backdrop: 'static',
        });
        dialogRef.componentInstance.modalMessage =
            Type == 0
                ? this.transLocoService.translate('IDMS.REPORTS.ARE_YOU_SURE_YOU_WANT_TO_DISABLE_SUBSCRIPTION')
                : this.transLocoService.translate('IDMS.REPORTS.ARE_YOU_SURE_YOU_WANT_TO_ENABLE_SUBSCRIPTION');

        dialogRef.result.then((result) => {
            if (result) {
                this.ngxUiLoaderService.start();
                var Data = {
                    scheduleId: data.data.schedule.scheduleId,
                    Enabled: Type == 0 ? false : true,
                };

                this.mgmtApi
                    .enableSubscription([Data])
                    .pipe(takeUntil(this.isSubscribe))
                    .subscribe(
                        (res) => {
                            if (res) {
                                this.customToastService.successToast(
                                    Type == 1
                                        ? this.transLocoService.translate('IDMS.REPORTS.SUBSCRIPTION_ENABLED_SUCCESSFULLY')
                                        : this.transLocoService.translate('IDMS.REPORTS.SUBSCRIPTION_DISABLED_SUCCESSFULLY'),
                                    'Success'
                                );
                                this.ngbModal.dismissAll();
                                this.datasource = [];
                                this.customDataSource = null;
                                this.enableReport = true;
                                this.LoadReport(this.reportId);
                                this.cd.detectChanges();
                            } else {
                                this.userUtilityService.errorModelPopup(res.message);
                            }
                            this.ngxUiLoaderService.stop();
                        },
                        (err) => {
                            this.ngxUiLoaderService.stop();
                        }
                    );
            }
        });
    }

    onCellPrepared(e: any) {
        e.cellElement.style.textAlign = 'center';
        if (e.rowType === 'data') {
            if (e.column.dataField === 'lastRunTime' && e.data.schedule.enabled == false) {
                e.cellElement.innerText = ``; // Modify display
            }
            if (e.column.dataField === 'lastRunStatus' && e.data.schedule.enabled == false) {
                e.cellElement.innerText = ``; // Modify display
            }
            if (e.column.dataField === 'nextRunTime' && e.data.schedule.enabled == false) {
                e.cellElement.innerText = ``; // Modify display
            }
            if (e.column.dataField === 'schedule.recurrenceType') {
                if (e.data.schedule.enabled == false) {
                    e.cellElement.style.textAlign = 'center';

                    // Set the width of the cell to 1000px
                    e.cellElement.style.width = '500px';

                    // Set position to absolute
                    e.cellElement.style.position = 'absolute';

                    e.cellElement.innerHTML =
                        '<h3 class="organization_title mt-5"><span>' + this.transLocoService.translate('IDMS.REPORTS.DISABLED') + '</span></h3>';
                } else {
                    e.cellElement.width = '250px'; // Hide the cell by setting display to 'none'
                    e.cellElement.innerText = this.getRecurrenceTypeLabel(e.data.schedule.recurrenceType);
                }
            }
        }
    }
    Disable(data: any) {
        return data;
    }

    ngOnDestroy() {
        this.isSubscribe.next(null);
        this.isSubscribe.complete();
    }
}
